import { useAsyncData, useRouteLocationWithLocale } from '#imports'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { ROUTES as PRODUCT_LIST_ROUTES } from '~/scopes/product-list/route-names'

export function useFetchPopularSearches() {
  const resolveLocalizedRoute = useRouteLocationWithLocale()
  const $httpFetch = useHttpFetch()
  const experiments = useExperiments()

  const isBrowsingHistoryEnabled =
    experiments['experiment.browsingHistoryPanel'] === 'enabled'

  return useAsyncData(
    'searchbar-popular-searches',
    () => $httpFetch('/bm/search/v3/popular'),
    {
      default: () => [],
      lazy: true,
      transform: (data) => {
        return data
          .filter(
            ({ link }) => !(link.type === 'internal' && !link.params.slugV2),
          )
          .map(({ highlightedTitle, title, landingId: id, link }) => ({
            highlightedTitle,
            title,
            id,
            url:
              link.type === 'external'
                ? link.href
                : resolveLocalizedRoute({
                    name: PRODUCT_LIST_ROUTES.PRODUCT_LIST,
                    params: {
                      slugV2: link.params.slugV2,
                      uuid: id,
                    },
                  }),
            type: isBrowsingHistoryEnabled ? 'popular' : undefined,
          }))
      },
    },
  )
}
